import {getAuthToken} from "@/functions/authTokenStorage";
import {snapshot as snapshotTelemetry} from "@/functions/telemetryCollector";

export function addAuthTokenInterceptor(client) {
    client.interceptors.request.use((config) => {
        const token = getAuthToken();

        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    });
}

export function addClientTelemetryInterceptor(client) {
    client.interceptors.request.use((config) => {
        try {
            if (config.url?.endsWith("game/save-answer")) {
                const summary = snapshotTelemetry();

                if (summary) {
                    config.headers = config.headers || {};
                    config.headers["X-Client-Telemetry"] = toBase64Utf8(JSON.stringify(summary));
                }
            }
        } catch {
        }

        return config;
    });
}

function toBase64Utf8(value) {
    const bytes = new TextEncoder().encode(value);
    let binary = "";

    bytes.forEach((byte) => {
        binary += String.fromCharCode(byte);
    });

    return btoa(binary);
}
